/**
 * Shared layout for the 3 legal pages (Privacy / Terms / Refund).
 * Provides a consistent sticky header with a back chevron, title, and
 * a scrollable main region with typography presets.
 */
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "lucide-react";

export function LegalLayout({ title, effectiveDate, children, testid }) {
  const navigate = useNavigate();
  return (
    <div className="app-page min-h-screen" data-testid={testid} style={{ background: "#F4F3F1" }}>
      <header className="sticky top-0 z-20 bg-canvas/90 backdrop-blur-xl border-b border-line2">
        <div className="max-w-3xl mx-auto h-14 px-4 flex items-center gap-2">
          <button
            onClick={() => navigate(-1)}
            data-testid="legal-back"
            aria-label="Back"
            className="-ml-2 w-10 h-10 grid place-items-center rounded-full hover:bg-white/60 transition-colors"
          >
            <ChevronLeft size={22} />
          </button>
          <h1 className="font-display text-[18px] sm:text-[20px] truncate">{title}</h1>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 pt-6 pb-24 text-[14px] leading-[1.65]" style={{ color: "#1A1A1A" }}>
        <div className="mb-6">
          <div className="text-[11px] uppercase tracking-[0.12em] text-ink-tertiary font-medium">Effective</div>
          <div className="text-[13px] text-ink-soft mt-0.5">{effectiveDate}</div>
        </div>
        <div className="legal-prose space-y-5">{children}</div>
        <div className="mt-12 pt-6 border-t border-line2 text-[12.5px] text-ink-soft">
          Questions? Reach us at{" "}
          <a href="mailto:support@fitfrik.com" className="underline">
            support@fitfrik.com
          </a>
          .
        </div>
      </main>
    </div>
  );
}

export function Section({ n, title, children }) {
  return (
    <section className="mt-6">
      <h2 className="font-display text-[17px] sm:text-[18px] mb-2" style={{ color: "#1A1A1A" }}>
        {n ? `${n}. ` : ""}
        {title}
      </h2>
      <div className="space-y-3 text-[13.5px] sm:text-[14px]" style={{ color: "#3A3833" }}>
        {children}
      </div>
    </section>
  );
}

export function List({ items }) {
  return (
    <ul className="list-disc pl-5 space-y-1.5">
      {items.map((t, i) => (
        <li key={i}>{t}</li>
      ))}
    </ul>
  );
}
